/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react';
import axios from 'axios';
import {connect} from 'react-redux'
import {
    Page,
    Preload,
    WKError
} from '../../components'
import {
    BanList,
    Header,
} from '../../components/liveroomLecturer'
import {Dialog} from 'react-weui'
import '../../css/page/LiveroomLecturerPage.css'
import BanTips from '../../images/ban-page-tips.png'
import errorImg from '../../images/no-source.png'
import {isPC} from '../../utils'

class liveroomlecturerBan extends React.Component {

    constructor() {
        super();
        this.state = {
            alertShow: false,
            accountIds:'',
            idOrName: 'account_ids',
            isOpen: false,
            searchParams:{},
            alertIntro: {
                title: '温馨提示',
                buttons: [
                    {
                        label: '关闭',
                        onClick: this.handleHideAlert.bind(this),
                        type:'warn'
                    }
                ]
            },
            submitTipShow: false,
            submitErrorShow: false,
            dialogMsgType: 'format',
            submitTip: {
              title: '温馨提示',
                buttons: [
                    {
                        label: '关闭',
                        onClick: this.handleHideSubmitTip.bind(this)
                    }
                ]
            }
        }
        this.cancelOpen = this.cancelOpen.bind(this)
    }

    componentDidMount() {
        let id = this.props.routeParams.liveroom_id;
        document.title = '店铺黑名单';
        this.props.dispatch({
            type: 'LIVEROOM_ID_SAVE',
            payload: id
        });
        this.reqList()
        document.addEventListener(isPC() ? 'click' : 'touchend', this.cancelOpen )
    }
    componentWillUnmount() {
      document.removeEventListener(isPC() ? 'click' : 'touchend', this.cancelOpen )
    }

    cancelOpen(){
      if(!this.state.isOpen) return
      this.setState({
        isOpen: false
      })
    }

    reqList(params) {
      let id = this.props.routeParams.liveroom_id;
      axios.get(`/api/liveroom/${id}/block/list`, { params })
            .then(res => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'LIVEROOM_BAN_LIST',
                        payload: res.data.data.accounts
                    });
                   this.props.dispatch({
                       type: 'LIVEROOM_BAN_INIT',
                       payload: res.data.data
                   });
                }

                if(res.data.code === -1) {
                  this.setState({
                    submitTipShow: true,
                    dialogMsgType : 'error'
                  })
                }
            }).catch((error) => {
            if (error.response && error.response.status === 404) {
              this.props.dispatch({
                  type: 'ERROR_SHOW',
                  payload: {
                      tips: '网络连接出问题了。',
                      img: errorImg,
                      href: '/?st=liveroom_setting_ban_404',
                      btn: '去首页看看'
                  }
              });
              return
            }else if (error.response && error.response.status === 403){
              this.props.dispatch({
                  type: 'ERROR_SHOW',
                  payload: {
                      tips: '你没有查看此内容的权限。',
                      img: errorImg,
                      href: '/?st=liveroom_setting_ban_403',
                      btn: '去首页看看'
                  }
              });
              return
            }

            this.setState({
              submitTipShow: true,
              dialogMsgType : 'error'
            })
        });
    }

    handleHideAlert() {
        this.setState({
            alertShow: false
        })
    }

    handleShowAlert() {
      this.setState({
          alertShow: true
      })
    }

    handleHideSubmitTip() {
      this.setState({
        submitTipShow: false
      })
    }

    idOrNameChange = (event, type) => {
      // 阻止合成事件的冒泡
      event.stopPropagation()
      // 阻止与原生事件的冒泡
      event.nativeEvent.stopImmediatePropagation()
      this.setState({
        accountIds: '',
        idOrName: type,
        isOpen: false
      })
    }

    handleClick() {
      this.setState({isOpen : !this.state.isOpen})
    }

    onSubmit(){
      const { idOrName, accountIds } = this.state
      // 判断一下用户id的格式
      if(idOrName === 'account_ids'){
        // 不符合这样格式：'id,id'
        const flag = accountIds && accountIds.split(',')
        .some(item =>
          isNaN(item) || item % 1 !== 0 || (accountIds && !item))
        if(flag){
          this.setState({
            submitTipShow: true,
            dialogMsgType : 'format'
          })
          return
        }
      }
      const searchParams = {
        nickname: idOrName === 'nickname' && accountIds ?  accountIds : undefined,
        account_ids: idOrName === 'account_ids' && accountIds ?  accountIds : undefined,
      }
      this.setState({
        searchParams
      })
      this.reqList(searchParams)
    }

    render() {
        const {error} = this.props;
        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }

        const {liveroomSetting} = this.props;

        if (!liveroomSetting.liveroomBanInit){
            return <Preload/>
        }

        const {alertIntro, alertShow, submitTip, submitTipShow, accountIds, idOrName, isOpen} = this.state;

        return (
            <Page>
                <div className="liveroom-setting-ban-page liveroom-setting-ban-wrap">
                    <Dialog className='ban-page-diglog'  type="ios" title={alertIntro.title} buttons={alertIntro.buttons} show={alertShow}>
                        <div className="ban-tips-alert">
                            <img src={BanTips} alt=""/>
                            <p>黑名单用户将无法在您店铺的课程内发表评论</p>
                        </div>
                    </Dialog>

                    {/* submitTipShow */}
                    <Dialog className='ban-page-diglog' type="ios" title={submitTip.title} buttons={submitTip.buttons} show={submitTipShow}>
                      {
                        this.state.dialogMsgType === 'format' ? <div>
                          <p>输入的用户ID格式不正确！</p>
                          <p>格式：多个用户ID使用英文逗号隔开</p>
                        </div>
                        :
                        <div>
                          <p>请求错误！</p>
                        </div>
                      }
                    </Dialog>

                    <div className="header-top">
                      <Header title={'黑名单管理'} isQuestion={true} onClickQuestion={this.handleShowAlert.bind(this)}/>
                      <div className={'account-ban-box'}>
                        <div className={'select-box'} onClick={() => { this.handleClick() }}>
                          <span className={'account-select'}>
                            {idOrName === 'account_ids' ? <span style={{marginRight:'4px'}}>ID</span> : '昵称'}
                          </span>
                          <span className={isOpen ? 'triangle-bottom' : 'triangle-top'}></span>
                          <div className={'multi-select'}>
                          <div className={!isOpen ? 'option-select option-none' : 'option-select'}>
                            <ul className={'check-list'}>
                              <li onClick={event => { this.idOrNameChange(event, 'account_ids')}} className={idOrName === 'account_ids' && 'active'}>用户ID</li>
                              <li onClick={event => { this.idOrNameChange(event, 'nickname')}} className={idOrName === 'nickname' && 'active'}>用户昵称</li>
                            </ul>
                          </div>
                        </div>
                        </div>
                        <div className={'input-box'}>
                          <input
                            className={'account-input'}
                            placeholder={idOrName === 'account_ids' ? '可用英文逗号隔开多个ID' : '请输入用户昵称'}
                            value={accountIds}
                            onChange={(e) => {
                              this.setState({accountIds:
                                e.target.value
                              })
                            }}
                          />
                          <div className={'search-btn'} onClick={() => this.onSubmit()}>
                            <i className="iconfont icon-iconfontsousuo1"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 列表 */}
                    <BanList searchParams={this.state.searchParams}/>

                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    liveroomSetting: state.liveroomSetting,
    error: state.error,
}))(liveroomlecturerBan)


// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/LiveroomLecturerBan.js